import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import InputSelect from "../../shared/input/new/InputSelect"
import { RiMore2Line } from "react-icons/ri";
import Btn from "../../shared/button/Btn"
import { addDriverToRegularDriversList } from "../../../features/driversVehicles/driversVehiclesSlice"
const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;

        .content{

            display: flex;
            flex-direction: column;
            padding: 30px;

            p{
                font-size: 14px;
                font-weight: 600;
                text-align: center;
                line-height: 1.6;
                padding-bottom: 30px;
            }

            .driver-container{
                display: flex;
                flex-direction: column;
                gap: 10px;

                h3{
                    font-size: 16px;
                    width: 100%;
                    border-bottom: solid 1px ${({theme}) => theme.mainTextColor};
                    font-weight: 600;
                    padding-bottom: 8px;

                }

                .data-item{

                    display: flex;
                    align-items: center;
                    gap: 20px;
                    font-size: 14px;
                    font-weight: 600;

                    .key{
                        width: 140px;
                    }

                    .value{
                        width: 140px;
                    }

                    .err-text{
                        color: var(--color-main);
                        padding-bottom: 0;
                    }

                }

            }

            .vehicle-container{
                display: flex;
                flex-direction: column !important;
                gap: 5px;
                margin-top: 20px;

                h3{
                    font-size: 16px;
                    width: 100%;
                    border-bottom: solid 1px ${({theme}) => theme.mainTextColor};
                    font-weight: 600;
                    padding-bottom: 8px;
                }

                .vehicle-list{
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    padding-top: 8px;

                        .vehicle-item{

                            display: flex;
                            align-items: center;
                            gap: 20px;
                            font-size: 14px;
                            font-weight: 600;

                            .more-icon{
                                font-size: 2rem;
                            }
                        }
                }



            }

            .btn-container{
                margin-top: 30px;
                display: flex;
                flex-direction: row !important;
                justify-content: center;
                gap: 20px;
                width: 100%;
            }
        }
    }

`

const refOptions = [
    {
        id: 1,
        text: "Evet"
    },
    {
        id: 2,
        text: "Hayır"
    }
]

    //! 531 504 25 56
const AddDriverPhoneNumberExistingDescModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    const {regularDriverPhoneNumberQueryresponse, queriedPhoneNumberForRegularDriver} = useSelector(state => state.driversVehicles)

    const [error, setError] = useState(false)
    const [isSubmit, setIsSubmit] = useState(false)

    const [isRef, setIsRef] = useState({
        id: 0,
        text: ""
    })
    const [isRegular, setIsRegular] = useState({
        id: 0,
        text: ""
    })

    // //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        
        if(isSubmit){

            if(isRef.id && isRegular.id){
                setError(false)
            }
            else{
                setError(true)
            }
        }


    },[isRef.id, isRegular.id, isSubmit])

    const handleSubmit = () => {
        setIsSubmit(true)
        if(isRef.id && isRegular.id){
            const data = {
                phoneNumber: regularDriverPhoneNumberQueryresponse?.phoneNumber,
                isContinueVehicle: isRegular.id === 1 ? true : false,
                isReferenceDriver: isRef.id === 1 ? true : false
            }
            dispatch(addDriverToRegularDriversList(data))
        }
        else{
            setError(true)
        }
    }


  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <div className="content">
                <p>Sorguladığınız Telefon No ile üye kaydı bulunmaktadır. Üye bilgileri aşağıda gösterilmiştir. Sorguladığınız kişi bilgileri uyuyorsa Sürücülerim listenize ekleyebilirsiniz.</p>
            <div className="driver-container">
                <h3>Mevcut Sürücü Bilgileri</h3>
                <div className="data-item">
                    <div className="key">Adı Soyadı</div>
                    <div className="value">{regularDriverPhoneNumberQueryresponse?.adSoyadUnvan}</div>
                </div>
                <div className="data-item">
                    <div className="key">Telefonu</div>
                    <div className="value">{regularDriverPhoneNumberQueryresponse?.phoneNumber}</div>
                </div>
                <div className="data-item">
                    <div className="key">Devamlı Araç Mı?</div>
                     <InputSelect
                        initialOptions={refOptions}
                        data={isRef.text || ""}
                        setData={setIsRef}
                        inputWidth={"140px"}
                        labelText=""
                        name={"isRef"}
                    />
                    {
                        error && <p className="err-text">Lütfen Seçim Yapın</p>

                    }
                </div>
                <div className="data-item">
                    <div className="key">Referans Mısınız?</div>
                    <InputSelect
                        initialOptions={refOptions}
                        data={isRegular.text || ""}
                        setData={setIsRegular}
                        inputWidth={"140px"}
                        labelText=""
                        name={"isRegular"}
                    />
                    {
                        error && <p className="err-text">Lütfen Seçim Yapın</p>
                    }
                </div>
            </div>

            {
                regularDriverPhoneNumberQueryresponse &&
                <div className="vehicle-container">
                    <h3>Araçlar({parseInt(regularDriverPhoneNumberQueryresponse?.vehicles?.$values.length)} Araç)</h3>
                    <div className="vehicle-list">
                        {
                            regularDriverPhoneNumberQueryresponse?.vehicles?.$values?.slice(0, 5)?.map(item => (
                                <div className="vehicle-item">{item.plate} - {item.type} - {item.isReferenceDriver === 1 ? "Sürücü" : "İşveren"}</div>
                            ))
                        }
                        {
                            regularDriverPhoneNumberQueryresponse?.vehicles?.$values?.slice(0, 5)?.length > 5 &&
                            <div style={{fontSize: "1.3rem", fontWeight: 600}}>...</div>
                        }
                    </div>
                </div>
            }


            <div className="btn-container">
                <Btn bgColor="var(--color-main)" color="#fff" width={"180px"} handleClick={() => handleSubmit()}>Sürücülerime Kaydet</Btn>
                <Btn bgColor="transparent" color="var(--color-main)" width={"140px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
            </div>

        </div>
    </Container>
  )
}

export default AddDriverPhoneNumberExistingDescModal